import '../../../../node_modules/flag-icons/sass/flag-icons.scss'
import React, { useState } from 'react'
import ClickOutHandler from 'react-onclickout'

import './styles.scss'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'
import { getLanguagesOptios, renderFlag } from './utils'

/**
 * Selector lang
 * @param {object} props
 * @param {function} props.onChange
 * @param {string} props.value
 * @param {[string]} props.allowed
 * @param {object} [props.types]
 * @param {boolean} [props.hiddenFlags]
 * @param {'top'|'bottom'} [props.direction]
 * @param {boolean} [props.darkMode]
 */
const LangSelector = props => {
  const {
    allowed, types, value, onChange, hiddenFlags = false, direction = '', darkMode = false
  } = props

  const languagesOptions = getLanguagesOptios({ allowed })
  const [selectedValue, setSelectedValue] = useState(languagesOptions.find(lang => lang.value === value) || null)
  const [isOpenOptions, setIsOpenOptions] = useState(false)

  const toggleOptions = () => setIsOpenOptions(prevState => !prevState)

  const handleSelect = lang => {
    setSelectedValue(lang)
    if (typeof onChange === 'function') onChange(lang)
    toggleOptions()
  }

  return (
    <div className='lang-selector'>
      <button className='lang-selector__header' onClick={toggleOptions}>
        {
          hiddenFlags
            ? null
            : (
              <div className='lang-selector__flag-container'>
                {selectedValue?.value ? (
                  renderFlag(selectedValue.value)
                ) : (
                  <figure className='lang-selector__icon'>
                    <img src={getStaticImage('/icons/orange-brand/icon-earth-dark.svg')} alt='Global' />
                  </figure>
                )}
              </div>
            )
        }
        <p className={darkMode ? 'lang-selector__text-dark-mode text-ellipsis' : 'lang-selector__text text-ellipsis'}>
          {
            lang(languagesOptions?.find(l => l.value === selectedValue?.value)?.label || 'dashboard_language')
          }
        </p>
        <figure className='lang-selector__icon'>
          <img src={getStaticImage('/icons/orange-brand/icon-arrow-down-grey.svg')} alt='Collapse' />
        </figure>
      </button>
      {isOpenOptions ? (
        <ClickOutHandler onClickOut={toggleOptions}>
          <ul className={`lang-selector__options${direction === 'top' ? '-top': ''}`}>
            {languagesOptions.map((lang, key) => (
              <li
                key={key}
                className='lang-selector__options-item'
                onClick={() => handleSelect(lang)}
              >
                {
                  hiddenFlags
                    ? null
                    : renderFlag(lang.value)
                }
                <p className='lang-selector__text text-ellipsis' title={lang.label}>
                  {lang.label}
                </p>
                {
                  types
                    ? (
                      <figure className='lang-selector__icon'>
                        {types?.[lang.value] === 'default' ? (
                          <img src={getStaticImage('/icons/orange-brand/icon-tick-circle-clean-secondary-dark.svg')} alt='Default' />
                        ) : null}
                        {types?.[lang.value] === 'operator' ? (
                          <img src={getStaticImage('/icons/orange-brand/icon-tick-circle-secondary-dark.svg')} alt='Selected' />
                        ) : null}
                        {types?.[lang.value] === 'generated' ? (
                          <img src={getStaticImage('/icons/orange-brand/icon-robot-face-warning.svg')} alt='Bot' />
                        ) : null}
                      </figure>
                    ) : null
                }
              </li>
            ))}
          </ul>
        </ClickOutHandler>
      ) : null}
    </div>
  )
}

export default LangSelector
